import type { FormField } from "@/shared/types/estateEssentials";

export function resolveFieldOptions(
  field: FormField,
  formValues: Record<string, string>,
): FormField {
  if (!field.dependsOn) return field;
  const depValue = formValues[field.dependsOn] ?? "";
  if (field.optionsByKey && depValue) {
    return { ...field, options: field.optionsByKey[depValue] ?? [] };
  }
  return field;
}

/**
 * Returns true if a field should be hidden based on conditional visibility rules.
 */
export function isFieldHidden(field: FormField, formValues: Record<string, string>): boolean {
  if (field.showWhen) {
    const currentValue = formValues[field.showWhen.field] ?? "";
    if (currentValue !== field.showWhen.value) return true;
  }
  if (field.type === "select" && field.dependsOn) {
    const resolved = resolveFieldOptions(field, formValues);
    return !!resolved.options && resolved.options.length === 0;
  }
  return false;
}
